import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/styles/theme.css'
import '@/styles/terminal.css'
import '@/styles/terminalRedesign.css'
import '@/styles/journal.css'
import App from '@/App'

const root = document.getElementById('root')
if (!root) throw new Error('#root not found')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
